module.exports = __webpack_public_path__ + "img/Gas_landpage.ac27f5a3.jpg";